import React from "react";
import { IconControl, Loading } from "spark-core-dx/components";
import "./resourceStateControl.scss";

const joinClassNames = (...classNames) =>
  classNames
    .flat()
    .filter(Boolean)
    .join(" ");

const normalizeActions = (actions) => {
  if (!actions) return [];
  return Array.isArray(actions) ? actions.filter(Boolean) : [actions];
};

const normalizeMessageLines = (message) => {
  if (!message) return [];
  return String(message).split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
};

export const ResourceStateControl = ({
  title,
  message,
  children,
  iconKey,
  loading = false,
  loadingText,
  tone = "neutral",
  compact = false,
  gridState = false,
  actions,
  className,
  role,
  headingLevel = 2
}) => {
  const renderedActions = normalizeActions(actions);
  const HeadingTag = headingLevel === 1 ? "h1" : "h2";
  const resolvedRole = role || (tone === "error" ? "alert" : undefined);
  const resolvedIconKey = iconKey || (tone === "warning" || tone === "error" ? "warning" : "");
  const messageLines = normalizeMessageLines(message);

  return (
    <div
      className={joinClassNames(
        "resource-state-control",
        loading ? "resource-state-control--loading" : "",
        tone && tone !== "neutral" ? `resource-state-control--${tone}` : "",
        compact ? "resource-state-control--compact" : "",
        gridState ? "resource-state-control--grid-state" : "",
        className
      )}
      role={resolvedRole}
    >
      {loading ? (
        <Loading type="spinner-2" size="2.5rem" />
      ) : resolvedIconKey ? (
        <IconControl iconKey={resolvedIconKey} width={compact ? "2.8rem" : "5.6rem"} height={compact ? "2.8rem" : "5.6rem"} />
      ) : null}
      {title ? <HeadingTag>{title}</HeadingTag> : null}
      {loadingText ? <span>{loadingText}</span> : null}
      {messageLines.length > 0 ? (
        <p>
          {messageLines.map((line, index) => (
            <React.Fragment key={`${line}-${index}`}>
              {index > 0 ? <br /> : null}
              {line}
            </React.Fragment>
          ))}
        </p>
      ) : null}
      {children}
      {renderedActions.length > 0 ? (
        <div className="resource-state-control__actions">
          {renderedActions.map((action, index) => (
            <React.Fragment key={action?.key || index}>{action}</React.Fragment>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default ResourceStateControl;
